<div class="apollo-main text-comparison">
    <!--  -->
    <header>
        <div class="data-header">
            <h2>Compare texts</h2>
            <p>You can extract the contents of your documents via open text extraction or use OCR in specific cases.</p>
        </div>
    </header>

    <!-- /////////////// INSTRUCTIONS ///////////// -->

    <div class="instructions">
        <a (click)="show = !show" class="trigger" [ngClass]="{'opened' : show == true}"><em>How does this work?</em></a>
        <ol *ngIf="show">
            <li><strong>Text is extracted</strong> by default using the appropriate method (open text by default).</li>
            <li>You can <strong>choose to use OCR</strong> in a specific language.</li>
            <li> You can <strong>REVIEW</strong> your <strong>list of changes</strong>.</li>
            <li>And choose <strong>COMPARE</strong> to highlight the differences in both documents.</li>
        </ol>
    </div>
    <!-- !ApolloReady -- return upload -->
    <core-helpers-box-alert-button *ngIf="!apolloReady" [text]="'Error: files not loaded.'" [buttonText]="'Back to upload'" (action)="returnToUpload()"></core-helpers-box-alert-button>

    <!-- Extract -->
    <plugin-apollo-helpers-content-extract *ngIf="apolloReady" (ready)="showCompareComponent = $event"></plugin-apollo-helpers-content-extract>
    <!-- <core-helpers-box-alert-try-again *ngIf="errorExtract && apolloReady" [text]="'It looks like something went wrong. Please try again.'" (tryAgain)="tryAgain('extract')"></core-helpers-box-alert-try-again> -->

    <!-- Compare -->
    <plugin-apollo-helpers-content-compared *ngIf="!errorCompare && apolloReady && showCompareComponent"></plugin-apollo-helpers-content-compared>
    <!-- <core-helpers-box-alert-try-again *ngIf="errorCompare && apolloReady" [text]="textError" (tryAgain)="tryAgain('compare')"></core-helpers-box-alert-try-again> -->
</div>
